import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";

export function useInsumosSearchDialogColumns() {
  const initialColumns = [
    { headerName: "ID insumo", field: "idInsumo", flex: 50 },
    { headerName: "Descripción", field: "descripcion", flex: 130 },
    { headerName: "Tipo", field: "tipoInsumo", flex: 70 },
    { headerName: "Elección", field: "eleccion", flex: 30 },
    { headerName: "Unidad", field: "unidad", flex: 70 },
  ];

  const columns = generateColumnsDefaultConfiguration(initialColumns, true);

  return columns;
}
